import React from "react";
import { Formik } from "formik";
import CustomTextbox from "../../../components/Forms/CustomInputs/CustomTextbox";

const VersionControlIosForm = ({ initialValues, handleFormSubmit }) => {
    return (
        <Formik
            initialValues={initialValues}
            // validationSchema={initiativeValidationSchema}
            onSubmit={(values, ...rest) => {
                // console.log('snvioesnvsev', data, rest);
                return handleFormSubmit(values, ...rest, 'ios');
            }}
        >
            {({
                values,
                errors,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
            }) => {
                return (

                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <CustomTextbox
                                fieldName="version_control.ios.minimum_version"
                                value={values.version_control?.ios?.minimum_version}
                                error={errors.version_control?.ios?.minimum_version}
                                label={"Minimum Servicable Version ios Version *"}
                                classes={"col-md-12"}
                                handleBlur={handleBlur}
                                inputType={"text"}
                                handleChange={(e) => {
                                    const val = e.target.value.trim();
                                    if (/^(\d+(\.\d{0,}){0,2})?$/.test(val)) {
                                        // if (e.target.value >= '0.0.1') {
                                        handleChange(e);
                                        // }
                                    }
                                }}
                            />
                            <CustomTextbox
                                fieldName="version_control.ios.threshold_version"
                                value={values.version_control?.ios?.threshold_version}
                                error={errors.version_control?.ios?.threshold_version}
                                label={"Force Update Threshold ios Version *"}
                                classes={"col-md-12"}
                                handleBlur={handleBlur}
                                inputType={"text"}
                                handleChange={(e) => {
                                    const val = e.target.value.trim();
                                    if (/^(\d+(\.\d{0,}){0,2})?$/.test(val)) {
                                        // if (e.target.value >= '0.0.1') {
                                        handleChange(e);
                                        // }
                                    }
                                }}
                            />
                            <div
                                className={`form-group col-md-12 mb-3 ${errors?.version_control?.ios?.message ? "is-invalid" : "is-valid"
                                    }`}
                            >
                                <label className="text-label">Message</label>
                                <textarea
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        const wordCount = value.trim().split(/\s+/).length;
                                        if (wordCount < 200) {
                                            setFieldValue('version_control.ios.message', value);
                                        } else {
                                            // Allow only if editing existing content (like backspace) or modifying within 200 words
                                            const lastChar = value.slice(-1);
                                            if (lastChar !== " " && value.trim().split(/\s+/).length <= 200) {
                                                setFieldValue('version_control.ios.message', value);
                                            }
                                        }
                                    }}
                                    onBlur={handleBlur}
                                    value={values?.version_control?.ios?.message}
                                    className="form-control"
                                    rows="6"
                                    name={'version_control.ios.message'}
                                    style={{ resize: "none" }}
                                />
                                {errors?.version_control?.ios?.message && (
                                    <div
                                        id="val-description-error"
                                        class="invalid-feedback animated fadeInUp"
                                        style={{ display: "block" }}
                                    >
                                        {errors?.version_control?.ios?.message}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="float-end">
                            <button
                                type="submit"
                                className="btn me-2 btn-primary"
                                disabled={isSubmitting}
                            >
                                Save
                            </button>
                        </div>
                        {/* <button className="btn btn-danger light">Cancel</button> */}
                    </form>
                )
            }}
        </Formik>
    )
}

export default VersionControlIosForm